module.exports = __webpack_public_path__ + "fontoctopus.84200d09800b6f6d6b36c793c47c0be5.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/resources/fonts/fontoctopus/fontoctopus.svg
// module id = 441
// module chunks = 8